export default "__VITE_ASSET__Bpbb793___"